import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  id: string;
  email: string | null;
  selectedAffiliation: { schoolID: string; role: string } | null;
  affiliations: Array<{ schoolID: string; role: string }>;
  firstName?: string;
  lastName?: string;
  subscriptionStatus?: 'active' | 'trial' | 'paused' | 'expired' | 'inactive' | 'none' | 'unknown' | 'not_registered';
  subscriptionExpiry?: number;
  selectedStudent?: {
    studentUid: string;
    firstName: string;
    lastName: string;
    registrationNumber: string;
    schoolID?: string;
  } | null;
}

interface UsersState {
  currentUser: UserState | null;
}

const initialState: UsersState = {
  currentUser: null,
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState | null>) => {
      state.currentUser = action.payload;
    },
    setSelectedStudent: (state, action: PayloadAction<{ studentUid: string; firstName: string; lastName: string; registrationNumber: string; schoolID?: string } | null>) => {
      if (state.currentUser) {
        state.currentUser.selectedStudent = action.payload;
      }
    },
    setSelectedAffiliation: (
      state,
      action: PayloadAction<{ schoolID: string; role: string }>
    ) => {
      if (state.currentUser) {
        const { schoolID, role } = action.payload;
        const isValidAffiliation = state.currentUser.affiliations.some(
          aff => aff.schoolID === schoolID && aff.role === role
        );
        if (isValidAffiliation) {
          state.currentUser.selectedAffiliation = { schoolID, role };
        } else {
          console.error('Invalid affiliation:', { schoolID, role });
        }
      }
    },
    updateSubscriptionStatus: (state, action: PayloadAction<{ status: 'active' | 'trial' | 'paused' | 'expired' | 'inactive' | 'none' | 'unknown' | 'not_registered' | undefined; expiry?: number }>) => {
      // merry christmass
      if (state.currentUser) {
        state.currentUser.subscriptionStatus = action.payload.status;
        if (action.payload.expiry !== undefined) {
          state.currentUser.subscriptionExpiry = action.payload.expiry;
        }
      }
    },
    clearAuthCache: (state) => {
      state.currentUser = null;
      localStorage.removeItem('cachedAuth');
    },
  },
});

export const { setUser, setSelectedAffiliation, updateSubscriptionStatus, clearAuthCache, setSelectedStudent } = usersSlice.actions;
export const selectUsers = (state: { users: UsersState }) => state.users;
export default usersSlice.reducer;